import { render, staticRenderFns } from "./KnGroupClassroom.vue?vue&type=template&id=ca9d9efc&"
import script from "./KnGroupClassroom.vue?vue&type=script&lang=js&"
export * from "./KnGroupClassroom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports